import { render } from "./FormLogoHeader.vue?vue&type=template&id=71e277c3&scoped=true"
import script from "./FormLogoHeader.vue?vue&type=script&lang=js"
export * from "./FormLogoHeader.vue?vue&type=script&lang=js"

import "./FormLogoHeader.vue?vue&type=style&index=0&id=71e277c3&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e277c3"],['__file',"src/components/patientReport/header/microgen/FormLogoHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71e277c3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71e277c3', __exports__)) {
    console.log('reload')
    api.reload('71e277c3', __exports__)
  }
  
  module.hot.accept("./FormLogoHeader.vue?vue&type=template&id=71e277c3&scoped=true", () => {
    console.log('re-render')
    api.rerender('71e277c3', render)
  })

}


export default __exports__